/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorComparator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorComparator");
    }

    getFixupPrototypeFunction() { return QueryOperatorComparator.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorComparator>): QueryOperatorComparator {
        let obj = Object.assign(new QueryOperatorComparator(), model);
        QueryOperatorComparator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorComparator>): QueryOperatorComparator {
        if (!model) return null;
        return QueryOperatorComparator.newInstance(<QueryOperatorComparator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorComparator) {
        if (!obj) return;

        models.QueryOperatorComparator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorComparator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorComparator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.a) {
            models.QueryOperator.fixupPrototype(this.a);
        }
    }

    /**
     * value of comparator query operator
     */
    a: models.QueryOperator;

}
